import { getWidth } from '@cabonline/ui-shared';
import { FC, ReactNode } from 'react';

import { LoadingSpinner } from '../../loading-spinner';
import { Text } from '../../text';
import { Modal } from '../modal';
import type { ModalProps } from '../types';
import { StyledContent } from './styles';

export interface LoadingModalProps {
  isOpen?: boolean;
  title: ModalProps['title'];
  text?: ReactNode;
}

export const LoadingModal: FC<LoadingModalProps> = ({
  isOpen = true,
  title,
  text,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      title={title}
      hideTitle
      width={{ desktop: getWidth('modal') }}
    >
      <StyledContent>
        <LoadingSpinner />
        <Text size="xl" as="h2" weight="extraBold" marginBottom="xs">
          {title}
        </Text>
        {text && typeof text === 'string' ? <Text size="l">{text}</Text> : text}
      </StyledContent>
    </Modal>
  );
};
